import React, { Component } from 'react';

import {
  Divider,
  Segment,
	Label
} from 'semantic-ui-react'

import './Or.css'

class Or extends Component{
  constructor(props){
    super(props)
  }

  render(){
    return(
      <Segment size={"mini"} basic style={this.props.isHidden ? {display: 'none'} : null} >
        <Divider horizontal className='divider-wrapper'>
					<Label className={this.props.pro ? 'divider-title-pro' : 'divider-title'}>
						<span>{this.props.text}</span>
					</Label>
				</Divider>
      </Segment>
    )
  }
}

export default Or;



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/Or.jsx